<template>
  <div class="me-identity">
    <!-- Banda de identitate: avatar + nume + rol principal, pe suprafață tonală
         neutră, ca datele de context de dedesubt să rămână pe alb. -->
    <div class="me-identity__head">
      <span class="me-identity__avatar" aria-hidden="true">{{ initials }}</span>
      <div class="me-identity__who">
        <h2 class="me-identity__name">{{ user.name || "—" }}</h2>
        <p class="me-identity__email">{{ user.email || "—" }}</p>
        <span v-if="user.role" class="me-identity__role-pill">
          <v-icon size="14">mdi-shield-account-outline</v-icon>
          {{ user.role }}
        </span>
      </div>
    </div>

    <dl v-if="metaRows.length" class="me-identity__meta">
      <div v-for="row in metaRows" :key="row.label" class="me-identity__meta-row">
        <v-icon size="16" class="me-identity__meta-icon">{{ row.icon }}</v-icon>
        <dt class="me-identity__meta-label">{{ row.label }}</dt>
        <dd class="me-identity__meta-value">{{ row.value }}</dd>
      </div>
    </dl>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "UserIdentityCard",
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    initials: {
      type: String,
      default: "?",
    },
    metaRows: {
      type: Array,
      default: () => [],
    },
  },
});
</script>

<style scoped>
.me-identity__head {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 18px 16px;
  background: var(--app-neutral-chip-tonal-bg);
  border-bottom: 1px solid var(--ncrm-color-border-default);
}

.me-identity__avatar {
  display: grid;
  place-items: center;
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  border-radius: var(--app-radius-base);
  font-size: 1.25rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: rgb(var(--v-theme-on-primary));
  background: linear-gradient(
    150deg,
    rgb(var(--v-theme-primary)) 0%,
    color-mix(in srgb, rgb(var(--v-theme-primary)) 78%, #000) 100%
  );
}

.me-identity__who {
  min-width: 0;
}

.me-identity__name {
  margin: 0;
  font-size: 1.02rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: var(--app-text-strong);
  overflow-wrap: anywhere;
}

.me-identity__email {
  margin: 2px 0 0;
  font-size: 0.78rem;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.6);
  overflow-wrap: anywhere;
}

.me-identity__role-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-top: 8px;
  padding: 3px 10px;
  border-radius: var(--app-radius-pill);
  background: var(--app-tertiary-soft-bg);
  border: 1px solid var(--app-tertiary-soft-border);
  color: var(--app-tertiary-soft-text);
  font-size: 0.74rem;
  font-weight: 700;
}

.me-identity__meta {
  margin: 0;
  padding: 14px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.me-identity__meta-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.me-identity__meta-row + .me-identity__meta-row {
  padding-top: 10px;
  border-top: 1px solid var(--ncrm-color-border-subtle);
}

.me-identity__meta-icon {
  flex-shrink: 0;
  color: rgba(var(--v-theme-on-surface), 0.45);
}

.me-identity__meta-label {
  flex: 1;
  min-width: 0;
  font-size: 0.78rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
}

.me-identity__meta-value {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 700;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: var(--app-text-strong);
}
</style>
